import React, { useRef, useState, FormEvent, useEffect } from 'react';
import classNames from 'classnames';
import { EnrichedActivity, Activity } from 'getstream';
import { Data as EmojiDataSet } from 'emoji-mart';

// import { Avatar } from './Avatar';
// TODO use mui version of Avatar?
import {
  Button,
  Textarea,
  TextareaProps,
  useFeedContext,
  useTranslationContext,
  CommentFieldProps,
} from 'react-activity-feed';

export type TigerNestedCommentFieldProps = {
  parentComment?: any;
  placeholder?: any;
  activity?: any;
  onSuccess?: any;
  className?: any;
  style?: any;
  emojiData?: any;
  trigger?: any;
  childInputRef?: any;
};

const TigerNestedCommentField: React.FunctionComponent<
  TigerNestedCommentFieldProps
> = (props) => {
  const feed = useFeedContext();
  const { t } = useTranslationContext();
  // const textareaReference = useRef<HTMLTextAreaElement>();
  // NOTE: To get autofocus on toggle working, we moved this `ref` to the parent
  // and are passing it here to the child in props.
  const textareaReference = props.childInputRef;
  const [text, setText] = useState<string>();

  const handleFormSubmit = async (
    event: FormEvent<HTMLFormElement> | KeyboardEvent
  ) => {
    event.preventDefault();

    if (!text) return;

    try {
      await feed.onAddChildReaction('comment', props.parentComment.id, {
        text,
      });
    } catch (error) {
      console.error(error);
    }

    setText('');
    props.onSuccess?.();
  };

  useEffect(() => {
    if (!textareaReference.current) return;

    const handleFormSubmitKey = (event: KeyboardEvent) => {
      const { current: textarea } = textareaReference;
      if (event.key === 'Enter' && textarea?.nextSibling === null) {
        handleFormSubmit(event);
      }
    };

    textareaReference.current.addEventListener('keydown', handleFormSubmitKey);

    return () =>
      textareaReference.current?.removeEventListener(
        'keydown',
        handleFormSubmitKey
      );
  }, []);

  return (
    <form
      onSubmit={handleFormSubmit}
      className={classNames('raf-comment-field', props.className)}
      style={props.style}
    >
      {/* {image && <Avatar image={image} circle size={39} />} */}
      {/* TODO use mui version of Avatar? */}
      <div className='raf-comment-field__group'>
        <Textarea
          rows={1}
          value={text}
          placeholder={props.placeholder ?? t('Start Typing...')}
          onChange={(event) => {
            const target = event.target as HTMLTextAreaElement;
            setText((pv) => target.value ?? event.currentTarget.value ?? pv);
          }}
          emojiData={props.emojiData}
          trigger={props.trigger}
          innerRef={textareaReference}
        />
        <Button buttonStyle='primary' disabled={!text} type='submit'>
          Reply
        </Button>
      </div>
      {/* TODO use mui button? probably not needed tho */}
    </form>
  );
};

export default TigerNestedCommentField;
